import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListTaxRates from "../../../../components/@tax/ListTaxRates";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TaxRatesPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListTaxRates
                routeType={routeType}
            />
        </SettingFrame>
    )
}       